<template>
  <div>
    <div class="flex items-center mb-4">
      <div class="text-xl text-text font-bold">{{ $t('allIncomes') }}</div>
    </div>
    <div class="grid grid-cols-2 col-gap-8">
      <div>
        <div class="text-text font-bold" style="font-size: 3.2rem;">
          {{ displayCurrencyValue(sumFact, spaceCurrency, true, true) }}
        </div>
        <div class="text-sm text-text-ternary">{{ $t('received') }}</div>
      </div>
      <div class="grid grid-cols-2 col-gap-4 items-end">
        <div class="text-right">
          <div class="text-xl text-text mb-1-5 font-bold">
            {{ displayCurrencyValue(sumPlan, spaceCurrency, false, true) }}
          </div>
          <div class="text-sm text-text-ternary">{{ $t('plan') }}</div>
        </div>
        <div class="text-right">
          <div class="text-xl mb-1-5 font-bold"
               :class="difference < 0 ? 'text-red':'text-green'">
            {{ displayCurrencyValue(difference, spaceCurrency, false, true) }}
          </div>
          <div class="text-sm text-text-ternary">{{ $t('difference') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BudgetsStatIncome",
  props: {
    sumPlan: {
      type: Number
    },
    sumFact: {
      type: Number
    },
    difference: {
      type: Number
    }
  },
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  methods: {},
  i18n: {
    messages: {
      en: {
        allIncomes: 'All incomes',
        received: 'Received',
        plan: 'Plan',
        difference: 'Difference',
      },
      ru: {
        allIncomes: 'Все доходы',
        received: 'Получено',
        plan: 'План',
        difference: 'Разница',
      }
    }
  }
}
</script>